/***
 * Difhub version: 1.0.0 draft
 * https://difhub.com/view/organizations/Business%20Systems/systems/Settlement/applications/Billing/datasets/InterCompany/versions/1
 */
export class InterCompanyDto {
  bu: string; // enum from api
  gl: string;

  constructor(d?: InterCompanyDto) {
    if (!d) {
      return;
    }

    this.bu = d.bu;
    this.gl = d.gl;
  }
}
